export default `<div">
    <p><strong>Growth Over the Last Six Years</strong></p>

    <p>In the past six years, we have exited investments amounting to more than half of our invested capital, with a
        book value appreciation exceeding 150 million USD (1 billion RMB). This places our capital dividend rate among
        the top 5% globally. Despite recent market challenges, our team has strategically positioned itself in seven
        cities worldwide, actively leading invested companies in exploring international markets, with our efforts never
        ceasing.</p>

    <p>Each year, we have anticipated future trends in the technology sector – investing in hard technology in 2019, the
        electric vehicle industry chain in 2020, global innovation in 2021, and focusing on the new generation of AI in
        the last two years. This approach has allowed us to invest with strong execution in the early stages of market
        development, yielding substantial returns.</p>



    <p><strong>The Evolution and Constants of FutureX - Persisting in the Hard but Right Choices</strong></p>

    <p>How will the world change in the next decade, and how can we invest better to achieve certain returns? In fact,
        FutureX began to layout in artificial intelligence in 2018, proactively foreseeing the arrival of the new
        generation of AI and the AGI era. Now, with the development of second-generation AI technology, we see a tenfold
        increase in business opportunities. Theoretically, in the future, any company not driven by AI might be
        eliminated from the global market.</p>



    <p><strong>AGI Era - Focusing on Scarce Data and Computing Power</strong></p>

    <p>We foresee that technological breakthroughs are becoming the protagonists of a new era. Although real estate
        currently accounts for 60% of global assets and technology a smaller share, in the next decade, a significant
        portion of wealth will shift from real estate and other industries to technology, accelerated by AI's
        productivity explosion.</p>

    <p>In this rapidly changing era, we must understand its essence. Similar to the agricultural era, the key elements
        of AI are data and computing power. Although algorithms and large models are crucial, the pace of technological
        iteration is very fast. As it accelerates, its commercial value tends to decrease. Therefore, we focus on
        investing in areas that can create scarce data and computing power.</p>

    <p>Our investment map evolves rapidly with time, helping us better position ourselves in the new generation of AI.
        In 2018 and 2019, our main investments were in companies at the application level, both in software and
        hardware, such as Meitu, ByteDance, Xiaomi, and NIO. Since 2022, we have returned to data and upstream areas,
        continuing to focus on intelligent applications that create data and companies representing the future of
        computing power acceleration.</p>

    <p>We have already invested in numerous data platforms and accumulated extensive knowledge on how the previous
        generation of AI has transformed industries such as healthcare, education, services, and e-commerce. Guided by
        our new investment map, this experience will be invaluable over the next decade, as AI will impact every
        industry to varying degrees, creating immense commercial value.</p>



    <p><strong>Macro Cycle: The Global Rise of a China-Centric Technology Supply Chain</strong></p>

    <p>While rapidly positioning ourselves in the current AI field, we are also considering the impact of the macro
        environment. Observing the rise of China leading to a Sino-U.S. technology divide, we envision the landscape for
        the next decade.</p>

    <p>Since the 1970s, the United States has established a pyramid division of labor, occupying the highest-profit
        sectors of high technology and finance. Over the past 30 years, China has gradually climbed from low-end
        manufacturing to high-tech, forming its own industrial pyramid covering every level from low-end manufacturing
        to high-tech. China's chip exports now account for a quarter of the global chip industry, while the U.S.
        accounts for half. China's rapid ascent has put it under significant global pressure.</p>

    <p>In the Sino-U.S. industrial pyramid, there's a new segment roughly equivalent to half of China's GDP – the
        overseas expansion of Chinese industries, including companies like ByteDance, Huawei Cloud, CATL, and Fuyao
        Glass. We expect this segment to at least double, equivalent to creating another China overseas.</p>

    <p>We hold a non-consensus optimistic view of this opportunity, as we see tremendous potential from frontline data
        and trends: U.S. dollar funds focus on Chinese companies going global and the U.S., bringing high-tech
        opportunities with awareness. We believe these are substantial incremental opportunities with high certainty and
        relatively low risk.</p>



    <p><strong>Tech Enterprises 5.0 - More Prominent Growth Flywheel</strong></p>

    <p>Returning to specific technology company investments, we note the rapid iteration and growth rate of enterprises.
        Through data analysis, we found that the time it takes for technology companies to reach annual revenues of 1
        billion is getting shorter, as demonstrated by ByteDance and OpenAI. This shows the high speed of industry
        development driven by AI, especially in commercialization, with Chinese tech companies like ByteDance displaying
        astonishing speed.</p>

    <p>Why are technology companies growing faster? We believe it's due to their more significant growth flywheel,
        including lower computing costs, more powerful models, faster data processing capabilities, and improved user
        experiences. These factors collectively build high commercial barriers. We believe that even traditional fields
        not deeply penetrated by the internet and AI will see investment opportunities similar to ByteDance, which we
        are keenly investing in.</p>



    <p><strong>FutureX Strategy and Mission</strong></p>

    <p>Grasping the unchanging elements, efficiently empowering the most promising technology ecosystem at the world's
        turning point. In the midst of global changes, FutureX continues to adhere to our "people-centric" strategic
        core, deepening our understanding of technology, building trust with LPs and invested companies, and continually
        strengthening our advanced open-source culture.</p>

    <p>Faced with world-changing events, we adhere to key elements: outstanding founders, data, and computing power,
        believing that great achievements are created by people. We will continue to strive, believing that
        organizations that accumulate advanced experiences over the next decade will have more opportunities and achieve
        more outstanding results in the global innovation field.</p>

</div>`;
